import * as React from 'react';
import classnames from 'classnames';
import Button from '../Button/Button.js';
import { useBreakpoint } from '../MediaQuery/MediaQueryContext.js';
import '@grandvisionhq/utils';

const Expandable = ({ initialHeight =0 , showLessLabel , showMoreLabel , className , children , id ,  })=>{
    const currentBreakpoint = useBreakpoint();
    const contentContainerRef = React.useRef(null);
    const shouldUpdateToggleRef = React.useRef(true);
    const [isExpanded1, setIsExpanded] = React.useReducer((isExpanded)=>!isExpanded
    , false);
    const [showButton, setShowButton] = React.useState(true);
    React.useEffect(()=>{
        // Keeps record of the expanded state without triggering recalculation
        shouldUpdateToggleRef.current = !isExpanded1;
    }, [
        isExpanded1
    ]);
    /**
   * This effect checks if we should render the button
   * It runs whenever the breakpoint changes.
   * It will not update when the content is expanded because it breaks the calculation
   */ React.useEffect(()=>{
        if (!shouldUpdateToggleRef.current || !contentContainerRef.current) {
            return;
        }
        const contentContainer = contentContainerRef.current;
        const { height  } = contentContainer.getBoundingClientRect();
        setShowButton(contentContainer.scrollHeight > Math.ceil(height));
    }, [
        contentContainerRef,
        shouldUpdateToggleRef,
        currentBreakpoint
    ]);
    if (!children) {
        return null;
    }
    const toggleText = isExpanded1 ? showLessLabel : showMoreLabel;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('expandable', className, {
            _is_expanded: isExpanded1,
            'expandable--with-button': showButton
        })
    }, /*#__PURE__*/ React.createElement("div", {
        id: `expandable-${id}`,
        className: "expandable__body",
        style: {
            maxHeight: `${initialHeight}px`
        },
        ref: contentContainerRef
    }, children), showButton && /*#__PURE__*/ React.createElement(Button, {
        variant: "ghost",
        onClick: setIsExpanded,
        "aria-expanded": isExpanded1,
        "aria-controls": `expandable-${id}`,
        caption: toggleText,
        size: "custom"
    }));
};

export { Expandable as default };
//# sourceMappingURL=Expandable.js.map
